import { ApiCall } from './apiCall';
import { StreamConnector } from './StreamConnector';

export function createApiCallWithErrorHook(callApi: ApiCall, onError: (e: unknown) => void): ApiCall {
    return async function <T>(url: string, options: RequestInit | undefined) {
        try {
            return await callApi<T>(url, options);
        } catch (e) {
            onError(e);
            throw e;
        }
    };
}

export function createStreamConnectorWithErrorHook(connect: StreamConnector, onError: (e: unknown) => void): StreamConnector {
    return async function (url: string) {
        try {
            return await connect(url);
        } catch (e) {
            onError(e);
            throw e;
        }
    };
}
